import "../css/card_design.css"
import '../App.css';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import UserRegister from '../model/request/UserRegister';
import { useEffect, useState } from 'react';
import TopBar from './TopBar';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import LookUpRequest from "../model/request/LookupRequest";
import logo from '../images/logo.jpeg';
import 'bootstrap/dist/css/bootstrap.min.css';
import Offeradd from './Offeradd.js';
import { FaEye, FaEyeSlash } from "react-icons/fa";


function Place_screen() {
    const navigation = useNavigate()
    var location = useLocation();
    var { userRegister } = location.state || {};

    var [address1, setAddress1] = useState("");
    var [address1Error, setAddress1Error] = useState();

    var [address2, setAddress2] = useState("");
    var [address2Error, setAddress2Error] = useState();

    var [Country, setCountry] = useState("");
    var [CountryError, setCountryError] = useState();


    var [stateList, setStateList] = useState([]);
    var [State, setState] = useState("");
    var [StateItem, setStateItem] = useState("");
    var [StateId, setStateId] = useState("");
    var [StateError, setStateError] = useState();

    var [districtList, setDistrictList] = useState([]);
    var [District, setDistrict] = useState("");
    var [DistrictId, setDistrictId] = useState("");
    var [DistrictError, setDistrictError] = useState();

    var [mothertongue, setmothertongue] = useState("");
    var [mothertongueError, setmothertongueError] = useState();
    var [password, setPassword] = useState('');
    var [PasswordError, setPasswordError] = useState();
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        // Redirect if no userRegister
        if (!userRegister) {
            navigation('/');
        } else {
            // Call API only if userRegister exists
            stateAPICall();
        }
    }, [userRegister, navigation]);


    if (userRegister == null) {
        return null;
    }
    // var userObject = Object.setPrototypeOf(userRegister, UserRegister.prototype);
    async function clicktoReligionscreen() {


        if (validation()) {
            userRegister.countryId = 103;
            userRegister.stateId = parseInt(StateId);;
            userRegister.districtId = parseInt(DistrictId);;
            userRegister.mother_Tongue = parseInt(mothertongue);
            userRegister.password = await ApiConfig.encrypt(password);
            userRegister.line_1 = address1;
            userRegister.line_2 = address2;

            navigation('/Religion', { state: { userRegister } })

        }
    }
    // useEffect(() => {
    //     stateAPICall();
    // }, []);

    function stateAPICall() {
        var request = new LookUpRequest();
        request.countrycode = "IN";
        console.log("Response:", JSON.stringify(request));
        axios.post(
            ApiConfig.getUrl("User/state"),
            JSON.stringify(request),
            {
                headers: {
                    "Content-Type": "application/json",
                }
            }
        )
            .then(response => {
                // setStateList(response.dataList)
                console.log("Responsesadsadsad:", response.data.response);
                const dataList = response.data.response.dataList;
                console.log("Responsesa:", dataList);
                setStateList(dataList)
                // navigation('/Verify', { state: { userRegister: userObject } })

            })
            .catch(error => {
                console.error("Error:", error);
            });
    }

    function districtAPICall(code) {
        var request = new LookUpRequest();
        request.state_code = code;
        console.log("Response:", JSON.stringify(request));
        axios.post(
            ApiConfig.getUrl("User/district"),
            JSON.stringify(request),
            {
                headers: {
                    "Content-Type": "application/json",
                }
            }
        )
            .then(response => {
                console.log("Responsesadsadsad:", response.data.response);
                const dataList = response.data.response.dataList;
                console.log("Responsesa:", dataList);
                setDistrictList(dataList)

            })
            .catch(error => {
                console.error("Error:", error);
            });
    }

    function validation() {

        var isFlage = true

        if (address1 == "") {
            setAddress1Error("Type your Address line 1.")
            isFlage = false
        }
        else {
            setAddress1Error("")
        }
        if (address2 == "") {
            setAddress2Error("Type your Address line 2.")
            isFlage = false
        }
        else {
            setAddress2Error("")
        }

        if (Country == "") {
            setCountryError("Select Your Country.")
            isFlage = false
        }
        else {

            setCountryError("")
        }
        if (State == "") {
            setStateError("Select Your State.")
            isFlage = false
        }
        else {
            setStateError("")
        }
        if (District == "") {
            setDistrictError("Select Your District.")
            isFlage = false
        }
        else {
            setDistrictError("")
        }

        if (mothertongue == "") {
            setmothertongueError("Select Your Mother Tongue.")
            isFlage = false
        }
        else {
            setmothertongueError("")
        }
        if (!password.trim()) {
            setPasswordError('Please Enter Your Password.');
            isFlage = false;
        } else if (password.length < 8 || !/\d/.test(password)) {
           setPasswordError( "Password must be at least 8 characters long and contain at least one uppercase letter.");
            isFlage = false;
        } else {
            setPasswordError('');
        }
        return isFlage;
    }

    const disableRightClick = (e) => {
        e.preventDefault();
    };

    return (
        <>
            <div className='fullview' onContextMenu={disableRightClick}>
                <TopBar />
                <div className='container mt-4'>
                    <div className='row mt-5 align-items-center gx-0'>
                        <div className="col-lg-5 col-12 p-4 d-flex justify-content-center align-items-center mt-3">
                            <img className='image h-100 w-100' src={logo} alt='logo' />
                        </div>

                        <div className="col-lg-6 col-12 card p-3">


                            <p className="h5 text-center mt-2 pt-2">Basic Details</p>
                            <input
                                type="text"
                                placeholder="D/No,street,Area"
                                className="form-control mt-2"
                                value={address1}
                                onChange={(e) => setAddress1(e.target.value)}
                            />
                            <span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }} >{address1Error}</span>
                            <input
                                type="text"
                                placeholder="Village/Town"
                                className="form-control mt-2"
                                value={address2}
                                onChange={(e) => setAddress2(e.target.value)}

                            />
                            <span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }}>{address2Error}</span>


                            <select id="Country" className="form-control mt-2" value={Country} onChange={(e) => setCountry(e.target.value)}>
                                <option value="">--Country-- </option>
                                <option value="IN">India</option>
                            </select>
                            <span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }} >{CountryError}</span>

                            <select id="State" className="form-control mt-2" value={State}
                                onChange={(e) => {
                                    // console.log("Responsesadsadsad:", e.target.key);
                                    // const obj = JSON.parse(e.target.value);

                                    const selectedState = stateList.find(s => s.code === e.target.value);
                                    setStateItem(selectedState);
                                    setState(selectedState.code);
                                    setStateId(selectedState.id);
                                    districtAPICall(e.target.value);
                                    console.log("Responsesadsadsad:", e.target.value);
                                    // }
                                }}>
                                <option value="">--State--</option>
                                {stateList.map((item) => (
                                    <option key={item.id} value={item.code}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                            <span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }} >{StateError}</span>

                            <select id="District" className="form-control mt-2" value={District}
                                onChange={(e) => {
                                    setDistrict(e.target.value)
                                    console.log("Responsesadsadsad:", e.target.value);
                                    setDistrictId(e.target.value)
                                }}>
                                <option value="">--District--</option>
                                {districtList.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                            <span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }}>{DistrictError}</span>

                            <select id="mothertongue" className="form-control mt-2" value={mothertongue} onChange={(e) => setmothertongue(e.target.value)}>
                                <option value="">--Mother Tongue-- </option>
                                <option value="1">Angika</option>
                                <option value="2">Arunachali</option>
                                <option value="3">Asami</option>
                                <option value="4">Awadhi</option>
                                <option value="5">Bengali</option>
                                <option value="6">Bojpuri</option>
                                <option value="7">Brij</option>
                                <option value="8">Bihari</option>
                                <option value="9">Badaga</option>
                                <option value="10">Chatisgari</option>
                                <option value="11">Dogri</option>
                                <option value="12">English</option>
                                <option value="13">French</option>
                                <option value="14">Garhwali</option>
                                <option value="15">Garo</option>
                                <option value="16">Gujarati</option>
                                <option value="17">Haryanvi</option>
                                <option value="18">Himachali/Pahari</option>
                                <option value="19">Hindi</option>
                                <option value="20">Kanauji</option>
                                <option value="21">Kanada</option>
                                <option value="22">Kashmiri</option>
                                <option value="23">Khandesi</option>
                                <option value="24">Khasi</option>
                                <option value="25">Khonkani</option>
                                <option value="26">Koshali</option>
                                <option value="27">Kumaoni</option>
                                <option value="28">Kutchi</option>
                                <option value="29">Lepcha</option>
                                <option value="30">Ladacki</option>
                                <option value="31">Magahi</option>
                                <option value="32">Maithili	</option>
                                <option value="33">Malayalam</option>
                                <option value="34">Manipuri	</option>
                                <option value="35">Marathi</option>
                                <option value="36">Marwari</option>
                                <option value="37">Miji	</option>
                                <option value="38">Mizo	</option>
                                <option value="39">Monpa</option>
                                <option value="40">Nicobarese</option>
                                <option value="41">Nepali</option>
                                <option value="42">Oriya</option>
                                <option value="43">Panjabi</option>
                                <option value="44">Rajasthani</option>
                                <option value="45">Sanskrit</option>
                                <option value="46">Santhali</option>
                                <option value="47">Sindhi</option>
                                <option value="48">Sourashtra</option>
                                <option value="49">Tamil</option>
                                <option value="50">Telugu</option>
                                <option value="51">Tripuri</option>
                                <option value="52">Tulu</option>
                                <option value="53">Urdu</option>
                                <option value="54">Bagri Rajastani</option>
                                <option value="55">Dhandhari/Jaipuri</option>
                                <option value="56">Gujari/Gojari</option>
                                <option value="57">Harauti</option>
                                <option value="58">Lambadi</option>
                                <option value="59">Malvi</option>
                                <option value="60">Mevari</option>
                                <option value="61">Mewati/Ahirwati</option>
                                <option value="62">Nimadi</option>
                                <option value="63">Shekhawati</option>
                                <option value="64">Wagdi</option>
                            </select> <span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }}>{mothertongueError}</span>





                            <div className="position-relative mt-2">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Password"
                                    className="form-control pe-5"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />

                                <span
                                    onClick={() => setShowPassword(!showPassword)}
                                    style={{
                                        position: "absolute",
                                        right: "15px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        color: "#6c757d"
                                    }}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                            <span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }}>{PasswordError}</span>

                            <button onClick={clicktoReligionscreen} className="btn w-100 mt-4 text-light" style={{ backgroundColor: "var(--primary-color)", fontWeight: "bold" }}>Next page</button>


                        </div>
                    </div>
                    <Offeradd />
                </div>

            </div>
            <footer className='bg-dark text-white text-center '>
                <label style={{ fontSize: "12px" }}>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
            </footer>

        </>
    );
}
export default Place_screen;